<template>
  <div class="brand-achievement-wrapper" v-if="achievementObj">
    <div class="box brand-achievement" :class="isNew ? 'new-brand-achievement' : ''">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteBrandAchievement(achievement.id)" v-if="!isNew"/>
      <b-field label="Заголовок">
        <b-input v-model='achievementObj.title'></b-input>
      </b-field>
      <b-switch v-model='achievementObj.isHidden' class="mt-10">Скрыть с сайта</b-switch> <br>
      <div class="link-wrapper" v-if="imageSrc">
        <img :src="imageSrc" /> <br>
        <button class="button is-danger delete-file" @click="deleteFile">Удалить изображение</button>
      </div>
      <b-field v-else class="mt-10">
        <button 
          @click="$refs.loadReviewFile.click()"
          class="button mt-10">
          Загрузить изображение
        </button> <br>
        <input type="file" ref="loadReviewFile" hidden @change='loadReviewFile'/>
      </b-field>
      <button class="button is-primary mt-10 save-button" @click="save" :disabled="disabled">СОХРАНИТЬ</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'BrandAchievementItem',
  data () {
    return {
      disabled: false,
      imageSrc: '',
      achievementObj: null
    }
  },
  props: {
    achievement: { }
  },
  created () {
    this.achievementObj = deepcopy(this.achievement || {
      title: '',
      isHidden: true,
      image: ''
    })
    if (this.achievementObj.image) {
      this.imageSrc = `/upload/photos/${this.achievementObj.image}`
    }
  },
  computed: {
    isNew () {
      return this.$route.name === 'BrandAchievementCreator'
    }
  },
  methods: {
    ...mapActions(['deleteBrandAchievement', 'updateBrandAchievement']),
    save () {
      if (this.achievementObj.title) {
        this.disabled = true
        let data = new FormData()
        data.append('data', JSON.stringify(this.achievementObj))
        data.append('image', this.achievementObj.image)
        this.updateBrandAchievement(data)
        .then(() => {
          this.disabled = false
          this.$router.push({ name: 'BrandAchievements' })
          this.$toast.open({
            message: 'Сохранено'
          })
        })
      } else {
        this.$toast.open({
          message: 'Заполните хотя бы одно поле',
          type: 'is-danger'
        })
      }
    },
    deleteFile () {
      this.imageSrc = ''
      this.achievementObj.image = ''
    },
    loadReviewFile (e) {
      const reader = new FileReader()
      reader.onload = e => {
        this.imageSrc = e.target.result
      }
      this.achievementObj.image = e.target.files[0]
      reader.readAsDataURL(e.target.files[0])
    }
  }
}
</script>

<style scoped>
.brand-achievement-wrapper {
  padding: 10px;
}
.brand-achievement .delete-icon {
  right: 9px;
  top: -13px;
}
.save-button {
  display: block;
  margin: 0 auto;
}
.link.mt-10 {
  display: inline-block;
}
.new-brand-achievement {
  max-width: 760px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// BrandAchievementItem.vue?3bfeb75c